// src/Divider.tsx
import styled from "@emotion/styled";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
var Content = styled.div(
  ({ theme, color, orientation, width, borderStyle }) => [
    { flexShrink: 0, margin: 0, backgroundColor: "transparent" },
    orientation === "horizontal" && {
      borderTopStyle: borderStyle,
      borderTopColor: color ?? theme.colors.border.default,
      borderTopWidth: width ?? theme.borders.width.default,
      width: "100%",
      height: width ?? theme.borders.width.default
    },
    orientation === "vertical" && {
      borderLeftStyle: borderStyle,
      borderLeftColor: color ?? theme.colors.border.default,
      borderLeftWidth: width ?? theme.borders.width.default,
      width: width ?? theme.borders.width.default,
      height: "100%"
    }
  ]
);
var component = {
  horizontal: "hr",
  vertical: "div"
};
var Divider = memo(
  ({
    orientation = "horizontal",
    color,
    width,
    borderStyle = "solid"
  }) => /* @__PURE__ */ jsx(Content, {
    as: component[orientation],
    orientation,
    color,
    width,
    borderStyle,
    role: "separator",
    "aria-orientation": orientation
  })
);
export {
  Divider
};
